module.exports = __webpack_public_path__ + "img/mobilephone.f7e9e492.jpeg";